import styled from 'styled-components';
import {legend} from 'styles/fragments';

export default styled.legend`
	${legend};
`;
